<template>
    <div class="modal fade text-left" id="company_setting_modal_update" tabindex="-1" role="dialog" aria-labelledby="myModalLabel33" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel33">Business Operation Settings</h4>
                    <div class="row">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                </div>
                <div class="modal-body">

                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link" id="affiliate_linkModal-tab" data-toggle="tab" href="#affiliate_linkModal"
                                    aria-controls="password" role="tab" aria-selected="false" ref="affiliate_modal_trigger" @click="activateTabs('affiliate_modal')">Affiliate Links</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link active" id="emailModal-tab" data-toggle="tab" href="#emailModal" aria-controls="password"
                                    role="tab" aria-selected="true" ref="email_modal_trigger" @click="activateTabs('email_modal')">Email Settings</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="sms_faxModal-tab" data-toggle="tab" href="#sms_faxModal"
                                    aria-controls="password" role="tab" aria-selected="false" ref="sms_modal_trigger" @click="activateTabs('sms_modal')">Fax Settings</a>
                            </li>

                            

                            <li class="nav-item">
                                <a class="nav-link" id="access-token-btn" data-toggle="tab" href="#access-token-tab" role="tab" ref="access_token_modal_trigger" @click="activateTabs('access_token_modal')">
                                    {{ localizationStore.translate('access.token') }}
                                </a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" id="api-settings-modal" data-toggle="tab" href="#api-settings-tab" role="tab" ref="api_settings_modal_trigger" @click="activateTabs('api_settings_modal')">
                                    {{ localizationStore.translate('api.settings') }}
                                </a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" id="recurly-modal" data-toggle="tab" href="#recurly-tab" role="tab" ref="recurly_modal_trigger" @click="activateTabs('recurly_modal')">
                                    {{ localizationStore.translate('billing.settings') }}
                                </a>
                            </li>

                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane mx-auto active" id="emailModal" aria-labelledby="emailModal-tab" role="tabpanel" ref="email_modal">
                                <email-modal></email-modal>
                            </div>

                            <div class="tab-pane mx-auto" id="sms_faxModal" aria-labelledby="sms_faxModal-tab" role="tabpanel" ref="sms_modal">
                                <sms-fax-modal></sms-fax-modal>
                            </div>

                            <div class="tab-pane mx-auto" id="affiliate_linkModal" aria-labelledby="affiliate_linkModal-tab" role="tabpanel" ref="affiliate_modal">
                                <company-affiliate-modal></company-affiliate-modal>
                            </div>

                            <div class="tab-pane mx-auto" id="access-token-tab" aria-labelledby="access_token-tab" role="tabpanel" ref="access_token_modal">
                                <access-token-modal></access-token-modal>
                            </div>

                            <div class="tab-pane mx-auto" id="api-settings-tab" aria-labelledby="api_settings-tab" role="tabpanel" ref="api_settings_modal">
                                <api-settings-modal></api-settings-modal>
                            </div>

                            <div class="tab-pane mx-auto" id="recurly-tab" aria-labelledby="recurly-tab" role="tabpanel" ref="recurly_modal">
                                <billing-setting />
                            </div>

                        </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../../stores/UserStore.js'
import { useBusinessStore } from '../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import EmailModal from './Settings/EmailModal.vue'
import LobModal from './Settings/LobModal.vue'
import SmsFaxModal from './Settings/SmsFaxModal.vue'
import CompanyAffiliateModal from './Settings/CompanyAffiliateModal.vue'
import CompanyContractSettingModal from './Settings/CompanyContractSettingModal.vue'
import AccessTokenModal from './Settings/AccessTokenModal.vue'
import ApiSettingsModal from './Settings/ApiSettingsModal.vue'
import Billing from './Settings/Billing.vue'
import axios from 'axios'
export default{
    components:{
        'billing-setting': Billing,
        EmailModal,
        LobModal,
        SmsFaxModal,
        CompanyAffiliateModal,
        CompanyContractSettingModal,
        AccessTokenModal,
        ApiSettingsModal
    },
    setup(){
        return{
            email_modal: ref(),
            sms_modal: ref(),
            affiliate_modal: ref(),
            access_token_modal: ref(),
            api_settings_modal: ref(),
            recurly_modal: ref(),
            userStore : useUserStore(),
            businessStore : useBusinessStore(),
            localizationStore : useLocalizationStore(),
        }
    },
    methods:{
        activateTabs(val){
            const array = ['email_modal','sms_modal','affiliate_modal','access_token_modal','api_settings_modal', 'recurly_modal'];
            array.forEach(element => {
                const tabTrigger = this.$refs[element+'_trigger'],
                tabActive = this.$refs[element];
                if(element == val){
                    tabTrigger.classList.add('active');
                    tabActive.classList.add('active');
                }else{

                    tabTrigger.classList.remove('active');
                    tabActive.classList.remove('active');
                }
            });
        }
    }
}
</script>
